import MDEditor from '@uiw/react-md-editor/nohighlight';

export const DisplayMarkdown = (props: { source: string }) => {
  return (
    <MDEditor.Markdown
      source={props.source}
      style={{ backgroundColor: 'unset', fontFamily: 'unset', color: '#24292f' }}
    />
  );
};
